// @ts-nocheck

import {useTranslation} from "@/Utils/CustomHooks/useTranslation";


export const checkPasswordStrength = (password = "") => {
    const checks = {
        minLength: password.length >= 12,
        hasNumber: /\d/.test(password),
        hasUppercase: /[A-Z]/.test(password),
        hasSpecialChar: /[^A-Za-z0-9]/.test(password),
    };

    const score = Object.values(checks).filter(Boolean).length;

    return {
        ...checks,
        score,
        isValid: score >= 3,
    };
};


export default class Common {
    static areDatesDefined(startdate, enddate): boolean {
        return (startdate && enddate) || (!startdate && !enddate)
            ? true
            : false;
    }

    /*
    * Parses a time string (0830 -> 08:30 OR 08:30 -> 0830 if inverse == true)
    * */
    static formatTimeString(str: string, inverse: boolean = false): string {
        if (!str || str.length < 3) {
            return inverse ? "0000" : "00:00";
        }

        if (str.length == 3) {
            str = '0' + str;
        }

        if (inverse) {
            return str.replace(':', '');
        }

        return str.substring(0, 2) + ':' + str.substring(2);
    }

    /*
    * Returns the last day of a given Date objects month as Date object
    * */
    static getLastDayOfMonth(date: Date): Date {
        const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        const year = lastDayOfMonth.getFullYear();
        const month = String(lastDayOfMonth.getMonth() + 1).padStart(2, '0');
        const day = String(lastDayOfMonth.getDate()).padStart(2, '0');

        return `${year}-${month}-${day} 00:00:00.000`;
    }

    /*
   * Finds and parses a fieldAction object
   * */
    static findAndParseFieldActions(fieldActions, action: string): object {
        let fieldAction = {};

        fieldActions?.forEach((jsonField) => {
            let field = JSON.parse(jsonField.JSONResponse);
            field = field[Object.keys(field)[0]]?.fields[0];

            if (field.name == action) {
                fieldAction = field;
                return;
            }
        })

        return fieldAction
    }

}
